import { render, staticRenderFns } from "./ExpenseDeleted.vue?vue&type=template&id=ecca8ef6&scoped=true&"
import script from "./ExpenseDeleted.vue?vue&type=script&lang=js&"
export * from "./ExpenseDeleted.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDeleted.vue?vue&type=style&index=0&id=ecca8ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca8ef6",
  null
  
)

export default component.exports